import { render, staticRenderFns } from "./TenderResults.vue?vue&type=template&id=d5bb416e&scoped=true"
import script from "./TenderResults.vue?vue&type=script&lang=js"
export * from "./TenderResults.vue?vue&type=script&lang=js"
import style0 from "./TenderResults.vue?vue&type=style&index=0&id=d5bb416e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bb416e",
  null
  
)

export default component.exports